import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["src"]

import { computed, onMounted, ref } from "vue";
import { useBookingStore } from "@/features/booking/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'MSBookingsFrame',
  setup(__props) {

const bookingStore = useBookingStore();

const frameHRef = computed(
  (): string => bookingStore.Filiale?.filiale.PublicUrl ?? "",
);

const loaded = ref(false);

onMounted(() => {
  const ef = document.getElementById("iframe") as HTMLObjectElement;
  ef.onload = () => (loaded.value = true);
});

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "iframe-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            id: "container",
            ref: "container"
          }, {
            default: _withCtx(() => [
              (!loaded.value)
                ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                    key: 0,
                    type: "card-avatar, article, actions"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("iframe", {
                id: "iframe",
                ref: "iframe",
                class: "iframe-bookings",
                src: frameHRef.value,
                width: "100%",
                height: "100%",
                tabindex: "0",
                allowfullscreen: "true",
                role: "none"
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})